export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const ACCEPT_PAYMENT = "ACCEPT_PAYMENT";
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const FETCH_SIGN_TEMPLATES = "FETCH_SIGN_TEMPLATES";
export const INITIATE_REFUND = "INITIATE_REFUND";
export const COMPLETE_REFUND = "COMPLETE_REFUND";